import Microgame from '../engine/Microgame.js';

export default class ChargeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Charge !`, en: `Charge!`, es: `¡Carga!` },
            controls: { fr: `Maintiens appuyé jusqu'à ce que la jauge atteigne la zone verte, puis relâche`, en: `Hold until the gauge reaches the green zone, then release`, es: `Mantén hasta que la barra llegue a la zona verde y suelta` },
            objective: { fr: `Relâche au bon moment pour charger correctement l'appareil`, en: `Release at the exact right time to charge device`, es: `Suelta en el momento exacto para cargar el dispositivo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><rect x="6" y="4" width="12" height="16" rx="2" ry="2"/><path d="M10 2h4"/><path d="M11 14h2l-1-4h3l-4-5v3H9z"/></svg>`,
            actions: [
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 100 },
                { type: 'tap', x: 50, y: 50, duration: 160 },
                { type: 'wait', duration: 700 },
            ],
            loopDuration: 3200
        };
    }
    constructor(engine) {
        super(engine);
        this.charge = 0;

        // --- GAME PARAMETERS ---
        this.duration = 3000; // Base time in ms
        this.baseRequiredCharge = 10; // Taps needed at base speed
        // -----------------------

        this.battery = null;
        this.level = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "CHARGE!";

        // Scale required taps based on available time
        // At max speed, 3000ms base drops to 750ms. 10 taps in 750ms is very hard.
        const timeRatio = this.engine.maxTime / this.duration;
        this.requiredCharge = Math.max(3, Math.round(this.baseRequiredCharge * timeRatio));

        // Battery Container
        this.battery = document.createElement('div');
        this.battery.style.position = 'absolute';
        this.battery.style.top = '50%';
        this.battery.style.left = '50%';
        this.battery.style.transform = 'translate(-50%, -50%)';
        this.battery.style.width = '100px';
        this.battery.style.height = '200px';
        this.battery.style.border = `5px solid ${this.primaryColor}`;
        this.battery.style.borderRadius = '10px';
        this.battery.style.padding = '5px';
        this.container.appendChild(this.battery);

        // Battery Top
        const top = document.createElement('div');
        top.style.position = 'absolute';
        top.style.top = '-15px';
        top.style.left = '50%';
        top.style.transform = 'translateX(-50%)';
        top.style.width = '40px';
        top.style.height = '10px';
        top.style.background = this.primaryColor;
        this.battery.appendChild(top);

        // Charge Level
        this.level = document.createElement('div');
        this.level.style.width = '100%';
        this.level.style.height = '0%';
        this.level.style.background = '#ff0055';
        this.level.style.position = 'absolute';
        this.level.style.bottom = '5px';
        this.level.style.left = '0';
        this.level.style.transition = 'height 0.1s, background 0.2s';
        this.battery.appendChild(this.level);

        // Tap Area (Full Screen)
        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (!this.active) return;

        this.charge++;
        const pct = (this.charge / this.requiredCharge) * 100;
        this.level.style.height = `${pct}%`;

        // Change color as it fills
        if (pct < 50) this.level.style.background = '#ff0055';
        else if (pct < 80) this.level.style.background = '#ccff00';
        else this.level.style.background = '#00f3ff';

        if (this.charge >= this.requiredCharge) {
            // Infinite / Time Attack Logic
            if (this.engine.activeChallenge && (this.engine.activeChallenge.mode === 'infinite' || (this.engine.activeChallenge.config && this.engine.activeChallenge.config.timeAttack))) {
                this.charge = 0;
                this.level.style.height = '0%';
                this.level.style.background = '#ff0055';

                this.engine.score++;
                this.engine.updateHUD();

                // Visual feedback for success
                const flash = document.createElement('div');
                flash.style.position = 'absolute';
                flash.style.top = '0';
                flash.style.left = '0';
                flash.style.width = '100%';
                flash.style.height = '100%';
                flash.style.background = 'rgba(255, 255, 255, 0.5)';
                flash.style.pointerEvents = 'none';
                this.container.appendChild(flash);
                setTimeout(() => flash.remove(), 100);
            } else {
                // Classic Mode
                this.win();
            }
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
